import '@theme/main.scss'
import '@assets/images/logo.svg'
import '@assets/images/logo-negative.svg'
import '@assets/images/logo-big.svg'
import '@assets/images/logo-big-negative.svg'
import '@assets/images/leaves.png'
import '@services/setup'